var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-tooltip tooltip show bs-tooltip-right",attrs:{"role":"tooltip"}},[_c('div',{staticClass:"arrow fixed-tooltip__arrow"}),_vm._v(" "),_c('div',{staticClass:"tooltip-inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }